import { useState, useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { VendorOnboardingModal } from "./VendorOnboardingModal";
import { CustomerOnboardingModal } from "./CustomerOnboardingModal";

const BASE = import.meta.env.BASE_URL.replace(/\/$/, "");

export function OnboardingGate({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const [showVendorModal,   setShowVendorModal]   = useState(false);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (!user) { setChecked(true); return; }

    if (user.role === "vendor" || user.role === "venue") {
      fetch(`${BASE}/api/business-profile/me`, { credentials: "include" })
        .then(r => r.json())
        .then((data: { profile: unknown }) => { if (!data.profile) setShowVendorModal(true); })
        .catch(() => {})
        .finally(() => setChecked(true));
    } else if (user.role === "user") {
      fetch(`${BASE}/api/customer-profile/me`, { credentials: "include" })
        .then(r => r.json())
        .then((data: { profile: unknown }) => { if (!data.profile) setShowCustomerModal(true); })
        .catch(() => {})
        .finally(() => setChecked(true));
    } else {
      setChecked(true);
    }
  }, [user, loading]);

  return (
    <>
      {children}
      {checked && showVendorModal && user && (user.role === "vendor" || user.role === "venue") && (
        <VendorOnboardingModal
          userRole={user.role as "vendor" | "venue"}
          onClose={() => setShowVendorModal(false)}
          onSubmitted={() => setShowVendorModal(false)}
        />
      )}
      {checked && showCustomerModal && user?.role === "user" && (
        <CustomerOnboardingModal
          onClose={() => setShowCustomerModal(false)}
          onSubmitted={() => setShowCustomerModal(false)}
        />
      )}
    </>
  );
}
